import { Package, AlertTriangle } from "lucide-react";

export function StepProduct({ process, candidates, allModels, onPick }) {
  const list = candidates.length ? candidates : allModels;
  const coilFed = !!process.consumes_item_id;
  return (
    <div className="space-y-4" data-testid="wiz-step-product">
      <div>
        <h3 className="font-heading text-lg font-semibold text-slate-900">{coilFed ? <>Which bottle model is <span className="text-blue-600">{process.name}</span> running for?</> : <>Which product is on <span className="text-blue-600">{process.name}</span>?</>}</h3>
        <p className="text-sm text-slate-500 mt-0.5">{coilFed ? "Each bottle model has its own pipe item and coil BOM — pick the one being made." : "This machine is linked to more than one product. Pick the one you are making."}</p>
      </div>
      {!candidates.length && (
        <div className="flex items-start gap-2 bg-amber-50 border border-amber-200 text-amber-800 rounded-lg p-3 text-sm" data-testid="wiz-no-link-warning">
          <AlertTriangle size={16} className="mt-0.5 shrink-0" />
          <span>No product is linked to this process yet. Showing all products — ask an admin to set “Link Processes” in Process Master.</span>
        </div>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {list.map((m) => (
          <button key={m.id} data-testid={`wiz-product-${m.id}`} onClick={() => onPick(m.name)}
            className="text-left bg-white border-2 border-slate-200 hover:border-blue-500 hover:ring-4 hover:ring-blue-100 rounded-xl px-4 py-3.5 transition-[border-color,box-shadow] flex items-center gap-3">
            <span className="w-9 h-9 rounded-lg bg-slate-100 flex items-center justify-center text-slate-500"><Package size={18} /></span>
            <span className="min-w-0">
              <span className="block font-semibold text-slate-800 leading-tight truncate">{m.name}</span>
              <span className="block text-xs text-slate-400 mt-0.5 capitalize">{m.item_type || "product"}</span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
